import './Issue.scss';

import { Card } from 'antd';
import { CodeItem } from '@ui/general/CodeItem';
import { IssueHeader } from './IssueHeader';
import React from 'react';

import { IssueBase, IssueVisibilityType } from '@sonar-software/sonar-issues';

export interface IssueProps {
	hideActions?: boolean;
	issue: IssueBase;
	visibility: IssueVisibilityType;
}

export const Issue: React.FC<IssueProps> = ({ issue, hideActions, visibility }) => {
	const { code, id, range } = issue;

	return (
		<Card
			className='issue'
			id={ `issue-${id}` }
			title={
				<IssueHeader
					hideActions={ hideActions }
					issue={ issue }
					visibility={ visibility } />
			}
			type='inner'>
			<CodeItem
				code={ code }
				sections={ range } />
		</Card>
	);
};
